import React from "react";
import styled from "styled-components";
import LoaderWrapper from "../../../../../components/Loaders/LoaderWrapper";
import PrivateHeader from "../../../../../components/PrivateHeader";
import ErrorBlockWithPermissions from "../../../../../components/UI/ErrorBlockWithPermissions";
import { Typography } from "@mui/material";
import FeedbackTableRetail from "./FeedbackTableRetail";
import OutstandingTable from "./OutstandingTable";
import ProgressHero from "./ProgressHero";
import QuizDetails from "./QuizDetails";
import Submissions from "./Submissions";
import useModuleDetailsV2 from "src/swr/hooks/RetailReports/useModuleDetailsV2";
import QuestionsReport from "../QuestionsReport";

const SubtitleText = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  color: rgb(23, 62, 88);
  margin-bottom: 8px;
  margin-top: 16px;
  margin-left: 4px;
`;

const Spacer = styled.div`
  background: transparent;
  height: 16px;
`;

const RetailProgress = ({ id }) => {
  const { data, isError, isLoading } = useModuleDetailsV2(id);

  if (isLoading) {
    return (
      <>
        <PrivateHeader header="Module Report" secondary />
        <LoaderWrapper text="Module report" />
      </>
    );
  }

  if (isError) {
    return <ErrorBlockWithPermissions errorObj={isError} />;
  }

  return (
    <>
      <PrivateHeader header="Module Report" secondary={data?.quiz?.name} />
      <QuizDetails
        quiz={data.quiz}
        submissions={data?.submissions}
        completions={data?.completions}
      />
      <ProgressHero
        locationProgress={data?.progress?.progress_by_location}
        assignedUsers={data?.progress?.assigned_users}
        moduleName={data?.quiz?.name}
      />
      <Spacer />
      <OutstandingTable
        selectedQuiz={data?.quiz}
        assignedUsers={data?.progress?.assigned_users}
      />
      <Spacer />
      <Submissions
        name={data?.quiz?.name}
        submissions={data?.submission_list}
      />
      {Boolean(data.feedback) && data.feedback.length > 0 && (
        <>
          <Spacer />
          <FeedbackTableRetail feedback={data.feedback} />
        </>
      )}
      {data?.submissions > 0 && (
        <>
          <Spacer />
          <QuestionsReport questions={data?.answers_breakdown} />
        </>
      )}
    </>
  );
};

export default RetailProgress;
